import { render, staticRenderFns } from "./SichernConnectEmailForm.vue?vue&type=template&id=12a7630c&scoped=true"
import script from "./SichernConnectEmailForm.vue?vue&type=script&lang=js"
export * from "./SichernConnectEmailForm.vue?vue&type=script&lang=js"
import style0 from "./SichernConnectEmailForm.vue?vue&type=style&index=0&id=12a7630c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a7630c",
  null
  
)

export default component.exports